import { DataType } from '@/core/data/DataType';
import { FView } from '@/core/FView';
import { ReportBlockWrapper } from './ReportBlockWrapper';

export class ReportBlocks {
    private static REGISTERED_BLOCKS : ReportBlockWrapper[] = [];

    public static RegisterTab(tab: ReportBlockWrapper): void {
        this.REGISTERED_BLOCKS.push(tab);
    }

    private static hasAll(types:DataType[]) : boolean {
        return types.every(type => FView.Get().dataManager.HasDataset(type));
    }

    public static GetAvailable() : ReportBlockWrapper[] {
        let tabs: ReportBlockWrapper[] = [];
        for (let tab of this.REGISTERED_BLOCKS) {
            if (this.hasAll(tab.requiredTypes) && tab.canBeDisplayed()) {
                tabs.push(tab);
            }
        }
        return tabs;
    }

}

// REQUIRE ALL USED REPORT-BLOCK .VUE-FILES HERE!!!
require('./ReportVisitors.vue');
require('./ReportEntranceDistribution.vue');
require('./ReportEnterExit.vue');

